import React from 'react';
import classNames from 'classnames';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import Hidden from '@material-ui/core/Hidden';
import Popper from '@material-ui/core/Popper';

// core components
import Button from 'components/CustomButtons/Button';

import styles from 'assets/jss/material-dashboard-pro-react/components/buttonMenuListStyle';

const useStyles = makeStyles(styles);

export default function ButtonMenuList({ name, menuItems, children, classesnames }) {
	const [openMenu, setOpenMenu] = React.useState(null);
	const handleClickButton = event => {
		if (openMenu && openMenu.contains(event.target)) {
			setOpenMenu(null);
		} else {
			setOpenMenu(event.currentTarget);
		}
	};
	const handleCloseMenu = () => {
		setOpenMenu(null);
	};
	const classes = useStyles();
	const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover);
	const buttonMenuListClasses = classNames({
		[classes.buttonMenuListClasses]: true
	}, classesnames);

	const renderMenuItems = menuItems.map(({ label, onClick }, i) => {
		return <MenuItem
			key={i}
			onClick={() => {
				onClick();
				handleCloseMenu();
			}}
			className={dropdownItem}
		>
			{label}
		</MenuItem>;
	});

	const iconClassName = classes.headerLinksSvg +
		' ' +
		classes.links;

	return (
		<div className={buttonMenuListClasses}>
			<Button
				color='transparent'
				aria-label={name}
				justIcon
				aria-owns={openMenu ? name + '-button-menu-list' : null}
				aria-haspopup='true'
				onClick={handleClickButton}
				className={classes.buttonMenuLink}
				muiClasses={{
					label: ''
				}}
			>
				{
					React.cloneElement(children, { className: `${children.props.className} ${iconClassName}` })
				}
				<Hidden mdUp implementation='css'>
					<span onClick={handleClickButton} className={classes.linkText}>
						{'Menu'}
					</span>
				</Hidden>
			</Button>
			<Popper
				open={Boolean(openMenu)}
				anchorEl={openMenu}
				transition
				disablePortal
				placement='bottom-end'
				className={classNames({
					[classes.popperClose]: !openMenu,
					[classes.popperResponsive]: true,
					[classes.popperNav]: true
				})}
			>
				{({ TransitionProps }) => (
					<Grow
						{...TransitionProps}
						id={name + '-button-menu-list'}
						style={{ transformOrigin: '0 0 0' }}
					>
						<Paper className={classes.dropdown}>
							<ClickAwayListener onClickAway={handleCloseMenu}>
								<MenuList role='menu'>
									{renderMenuItems}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</div>

	);
}
